import { FormControl } from "@angular/forms";
import { APIResponseI } from "./apiError.model";


// LogIn
export interface LoginForm {
    email: FormControl<string | null>;
    password: FormControl<string | null>;
    rememberMe: FormControl<boolean | null>
}

// ForgotPassword
export interface ForgotForm{
    email: FormControl<string | null>;
}

//Activate Account
export interface ActivateAccountForm{
  password :FormControl<string|null>
  confirmPassword:FormControl<string|null>
}

export interface LoginParamsI {
    email: string;
    password: string;
    rememberMe: boolean;
}

export interface LoginResponseI extends APIResponseI {
    isUser: boolean;
    isEmailVerified: boolean;
    isPhoneNumberVerified: boolean;
    model: UserDetail;
    requiresTwoFactor:boolean
}
export interface UserDetail {
    accessToken: string;
    refreshToken: string;
    userRole: Role;
    userName: string;
    firstName: string;
    lastName: string;
    fullName: string;
    masjidId: number | null;
    masjidName: string | null;
    organizationId: number |null;
    organizationName: string | null;
    phoneNumber: string;
    country?:string
    city?:string;
}

//Reset Password

export class ResetPasswordParamsI {
    userId: number = 0;
    password: string = '';
    confirmPassword: string = '';
    code: string = ''
}

//Activate Account

export class ActivateAccountParamsI {
    userId: number = 0
    code: string = ''
}

export interface ActivatedAccountResponseI extends APIResponseI {
    isUser: boolean;
    isEmailVerified: boolean;
    isPhoneNumberVerified: boolean;
}

// Set Account Password

export class SetAccountPasswordParamsI {
    userId: number = 0;
    password: string = '';
    confirmPassword: string = '';
}

// Refresh Token

export interface RefreshTokenParamsI {
    accessToken: string;
    refreshToken: string;
}

export interface RefreshTokenResponseI {
    accessToken: string;
    refreshToken: string;
}


// Role

export enum Role {
    MessageEditor = 'MessageEditor',
    Editor = 'Editor',
    MasterEditor = 'MasterEditor',
    Admin = 'Admin',
    Undefine = 'undefine'
}

export interface TwoFAVerification {
    email: string;
    code: string;
}

export interface TwoFAActivation{
    userId: number;
    twoFactorEnabled: boolean;
}